import { columnHelper } from './helper';

export const scheduledTime = columnHelper.accessor('scheduledTime', {
  header: 'Scheduled Time & Date',
});
